export const REPORT_STATUS_OBJECT: { [key: string]: string } = {
  UN_ANALYZED: "unAnalyzed",
  ANALYZING: "analyzing",
  ANALYZED: "analyzed",
}
